import React from 'react';

// =============================================
// Skeleton para Index (Admin) - Vista de tabla
// =============================================

const SkeletonRow = () => (
  <tr className="ui-fc-skeleton-row">
    <td style={{ width: "15%" }}>
      <div className="ui-fc-skeleton-name"></div>
    </td>
    <td style={{ width: "23%" }}>
      <div className="ui-fc-skeleton-link"></div>
      <hr />
      <div className="ui-fc-skeleton-sub-item"></div>
      <div className="ui-fc-skeleton-sub-item" style={{ width: '65%' }}></div>
    </td>
    <td>
      <div className="ui-fc-skeleton-link"></div>
      <hr />
      <div className="ui-fc-skeleton-format-item"></div>
      <div className="ui-fc-skeleton-format-item" style={{ width: '45%' }}></div>
      <div className="ui-fc-skeleton-format-item" style={{ width: '60%' }}></div>
    </td>
    <td className="text-right" style={{ width: "8%" }}>
      <div className="ui-fc-skeleton-action-btn"></div>
    </td>
  </tr>
);

const FormatCategoriesSkeleton = ({ rows = 5 }) => (
  <div className="content main-card mb-3 card">
    <div className="card-body">
      <table className="table table-hover table-striped table-bordered" id="sampleTable">
        <thead>
          <tr>
            <th style={{ width: "15%" }}>Nombre</th>
            <th style={{ width: "23%" }}>Sub Módulo</th>
            <th>Formatos</th>
            <th style={{ width: "8%" }}></th>
          </tr>
        </thead>
        <tbody>
          {[...Array(rows)].map((_, index) => (
            <SkeletonRow key={index} />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

// =============================================
// Skeleton item de módulo (icono + nombre + acciones)
// Replica: bw-fc-item bw-fc-item--folder
// =============================================

const ModuleItemSkeleton = ({ nameWidth = '60%' }) => (
  <li className="bw-fc-item bw-fc-item--folder ui-fc-skeleton-module-item">
    <div className="bw-fc-item__content">
      <div className="ui-fc-skeleton-module-icon"></div>
      <div className="ui-fc-skeleton-module-name" style={{ width: nameWidth }}></div>
    </div>
    <div className="bw-fc-item__actions">
      <div className="ui-fc-skeleton-module-action"></div>
      <div className="ui-fc-skeleton-module-action"></div>
      <div className="ui-fc-skeleton-module-action"></div>
    </div>
  </li>
);

// =============================================
// Skeleton para FormatCategoriesIndex - Vista columnas
// Columna izquierda con módulos + columnas vacias
// =============================================

const ITEMS_PER_COLUMN = [5, 4, 3, 4];
const NAME_WIDTHS = [
  ['60%', '45%', '75%', '50%', '65%'],
  ['55%', '70%', '40%', '60%'],
  ['65%', '50%', '80%'],
  ['45%', '70%', '55%', '65%'],
];

const FormatCategoriesShowSkeleton = ({ columns = 4 }) => (
  <div className="row ui-formatCategoriesIndex-containerRow">
    {[...Array(columns)].map((_, colIndex) => (
      <div className={`col-md-3 ${colIndex === 0 ? 'ui-formatCategoriesIndex-cardContainerModule' : ''}`} key={colIndex}>
        <div className={`card ${colIndex === 0 ? 'card-height ui-formatCategoriesIndex-cardHeight ui_height-card_principal' : 'card-height-navigation'} pb-0 bw-fc-card`}>
          <div className="card-body p-2">
            <ul className="list-unstyled mb-0">
              {[...Array(ITEMS_PER_COLUMN[colIndex] || 3)].map((_, itemIndex) => (
                <ModuleItemSkeleton
                  key={itemIndex}
                  nameWidth={(NAME_WIDTHS[colIndex] || NAME_WIDTHS[0])[itemIndex] || '55%'}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    ))}
  </div>
);

// =============================================
// Skeleton para Show (Usuario) - Vista columnas navegación
// =============================================

const ColumnCardSkeleton = ({ itemsCount = 4 }) => (
  <div className="col-md-3">
    <div className="bw-fc-card card-height-navigation">
      <div className="card-body pb-0 p-2">
        <div className="ui-fc-skeleton-column-items">
          {[...Array(itemsCount)].map((_, index) => (
            <div className="ui-fc-skeleton-column-item" key={index}>
              <div className="ui-fc-skeleton-column-icon"></div>
              <div className="ui-fc-skeleton-column-text" style={{ width: `${55 + (index * 12) % 40}%` }}></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const FormatCategoriesNavSkeleton = ({ columns = 4 }) => (
  <div className="ui-show-formatCategories-contianer-scroll-notOverflow">
    <div className="row">
      <div className="ui-show-formatCategories-container-columns-scroll" style={{ width: '100%' }}>
        {[...Array(columns)].map((_, index) => (
          <ColumnCardSkeleton key={index} itemsCount={3 + (index % 3)} />
        ))}
      </div>
    </div>
  </div>
);

export { FormatCategoriesSkeleton, FormatCategoriesShowSkeleton, FormatCategoriesNavSkeleton };
export default FormatCategoriesSkeleton;
